<template>
    <div class="mak-login-page">
        <v-card class="">
            <v-banner class="font-weight-bold title deep-purple--text">
                Giriş
            </v-banner>

            <div class="pb-6 px-8">
                <v-card-text>
                    <img
                        src="@/assets/logo.png" alt="Makairs Logo"
                        class="mak-giris-logo"
                    />
                </v-card-text>

                <v-form ref="form" lazy-validation v-model="valid">
                    <v-text-field
                        v-model="form.username"
                        :rules="rules.username"
                        required
                        outlined
                        label="Kullanıcı"
                        type="text"
                    />

                    <v-text-field
                        v-model="form.password"
                        :rules="rules.password"
                        required
                        outlined
                        label="Şifre"
                        type="password"
                    />

                    <v-btn
                        :loading="loading"
                        color="purple darken-1"
                        class="my-4"
                        elevation="2"
                        dark
                        @click="submit"
                    >
                        Giriş yap
                        <v-icon right>mdi-login</v-icon>
                    </v-btn>

                    <v-row justify="center" class="mt-4">
                        <v-alert
                            v-if="error"
                            type="error"
                        >
                            {{ error }}
                        </v-alert>

                        <v-alert
                            v-if="success"
                            type="success"
                        >
                            {{ success }}
                        </v-alert>
                    </v-row>
                </v-form>
            </div>
        </v-card>
    </div>
</template>

<script>
    import Vuex from 'vuex';

    export default {
        name: 'mak-login-page',
        data() {
            return {
                valid: false,
                loading: false,
                error: null,
                success: null,
                form: {
                    username: null,
                    password: null,
                },
                rules: {
                    username: [
                        v => !!v || 'Kullanıcı adını giriniz!',
                    ],
                    password: [
                        v => !!v || 'Şifrenizi giriniz!',
                    ],
                },
            };
        },
        computed: {
            ...Vuex.mapState(['user']),
        },
        methods: {
            ...Vuex.mapActions(['setJWT']),
            submit() {
                this.$refs.form.validate();
                this.$nextTick(() => {
                    if (this.valid) {
                        this.login();
                    }
                });
            },
            login() {
                this.success = null;
                this.error = null;
                this.loading = true;
                this.$requests.Auth.login(this.form)
                    .then((data) => {
                        this.setJWT(data.token);
                        setTimeout(() => {
                            // this.$router.push({ name: 'kontrol-paneli' });
                            this.success = 'Giriş başarılı!';
                            window.location = '/kontroller'
                        }, 400);
                    })
                    .catch((error) => {
                        console.error('error on login', error);
                        this.error = error?.message;
                    })
                    .then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>

<style lang="scss">
    .mak-login-page {
        display: flex;
        justify-content: center;

        .v-card {
            width: 30rem;
        }

        .mak-giris-logo {
            height: 5rem;
        }

        .v-text-field {
            input {
                padding: 8px 10px;
            }
        }
    }
</style>
